import store from '../store';

export const updateSelectedCoinSpotPrice = data => {
  store.selectedPriceAlertCoin.spotPrice = Number(data.p);
};

export const updateSelectedProduct = (data: { symbol: string }) => {
  store.selectedPriceAlertCoin.indexSymbol = data.symbol;
};
